'use strict';

import Map from './Map';

export default class SingleLocationMap extends Map
{
    constructor(bbox, distance) {
        super();
        this.bbox = bbox;
        this.lat = (parseFloat(this.bbox[0]) + parseFloat(this.bbox[1])) / 2;
        this.lng = (parseFloat(this.bbox[2]) + parseFloat(this.bbox[3])) / 2;
        this.distance = distance;

        this.draw();
    }

    draw() {
        super.draw(this.bbox, this.distance, false);
        this.addMarkers([{
            position: {
                lat: this.lat,
                lng: this.lng
            },
            markerNumber: 0,
            markerText: 'X'
        }]);
    }
}
